exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login-form--wrapper{padding:1rem}.login-link--wrapper{text-align:center}.login-link--wrapper a{font-size:.75rem}@media screen and (min-width:47.5em){.login-form{margin:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/AuthPages/LoginPage/LoginPage.scss
// module id = 702
// module chunks = 0